// Maps Cognito error codes / messages → Indonesian user-facing copy.
// Cognito errors come back with `code` (e.g. NotAuthorizedException) and
// sometimes only `message`. We match both, in this order.

const BY_CODE = {
  NotAuthorizedException: "Email atau password salah.",
  UserNotFoundException: "Akun dengan email tersebut tidak ditemukan.",
  UserNotConfirmedException:
    "Akun belum diverifikasi. Cek kotak masuk email Anda untuk kode verifikasi.",
  PasswordResetRequiredException:
    "Password Anda perlu di-reset. Klik 'Lupa password?' di bawah.",
  CodeMismatchException: "Kode verifikasi salah. Periksa lagi.",
  ExpiredCodeException:
    "Kode sudah kedaluwarsa. Minta kode baru.",
  InvalidPasswordException:
    "Password tidak memenuhi syarat: minimal 8 karakter, ada huruf besar, kecil, angka, dan simbol.",
  UsernameExistsException: "Email tersebut sudah terdaftar.",
  InvalidParameterException: "Data yang Anda masukkan tidak valid.",
  LimitExceededException:
    "Terlalu banyak percobaan. Coba lagi dalam beberapa menit.",
  TooManyRequestsException:
    "Terlalu banyak permintaan. Tunggu sebentar lalu coba lagi.",
  TooManyFailedAttemptsException:
    "Terlalu banyak percobaan gagal. Coba lagi nanti.",
  CodeDeliveryFailureException:
    "Gagal mengirim kode. Periksa kembali alamat email.",
  AliasExistsException: "Email tersebut sudah dipakai akun lain.",
  NetworkError:
    "Tidak ada koneksi ke server. Cek koneksi internet Anda.",
};

export function mapAuthError(err) {
  if (!err) return "Terjadi kesalahan. Coba lagi.";
  if (typeof err === "string") return err;
  const code = err.code || err.name;
  if (code && BY_CODE[code]) return BY_CODE[code];
  if (err.message && err.message.toLowerCase().includes("network")) {
    return BY_CODE.NetworkError;
  }
  return err.message || "Terjadi kesalahan. Coba lagi.";
}
